import { Icon, Typography } from '@fox/atoms';
import styled from 'styled-components';
import { useComponentStyleContext } from '../component-style-context';
import { MenuItem } from '../MegaMenu/contracts';
import { NAV_SEPARATOR } from './contracts';

enum RelativeHeaderPostion {
	CURRENT,
	PARENT,
	CHILD
}

/** To determine whether the items appear floating in from the right or left of the screen */
function determineRelativeHeaderPosition(path: string, navLocation: string): RelativeHeaderPostion {
	if (path === navLocation) {
		return RelativeHeaderPostion.CURRENT;
	}
	if (navLocation.length > path.length && navLocation.includes(path)) {
		return RelativeHeaderPostion.PARENT;
	}

	return RelativeHeaderPostion.CHILD;
}

const MenuItemWrapper = styled.div<{ position: RelativeHeaderPostion }>`
	transition: transform 0.4s cubic-bezier(0, 0, 0.2, 1);
	${props =>
		props.position === RelativeHeaderPostion.CURRENT
			? `
            opacity: 1;
            transform: translateX(0px);
        `
			: props.position === RelativeHeaderPostion.CHILD
			? `
            opacity: 0;
            pointer-events: none;
            transform: translateX(400px);
            height: 0px;
            padding: 0px;
        `
			: `
            opacity: 0;
            pointer-events: none;
            transform: translateX(-400px);
            height: 0px;
            padding: 0px;
`};
`;

const MenuItemContentWrapper = styled.div`
	padding: 1rem 1.5rem;
	padding-left: 2rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const LinkDivider = styled.hr`
	opacity: 0.1;
	margin: 0px;
	width: 100;
	border: 0.5px solid;
`;

export function HeaderLink({
	menuItem,
	navLocation,
	setNavLocation,
	path,
	currentUrl
}: {
	menuItem: MenuItem;
	navLocation: string;
	setNavLocation: React.Dispatch<React.SetStateAction<string>>;
	path: string;
	currentUrl: string;
}) {
	const relativeHeaderPosition = determineRelativeHeaderPosition(path, navLocation);
	const { linkHoverColour, linkHoverUnderline } = useComponentStyleContext();
	return (
		<div className="navbar-font-color-style">
			{menuItem.items?.length ? (
				<MenuItemWrapper
					onClick={() => {
						if (menuItem.items?.length) {
							setNavLocation(path + `${NAV_SEPARATOR}${menuItem.name}`);
							window.scrollTo({ top: 0, behavior: 'smooth' });
						}
					}}
					position={relativeHeaderPosition}
				>
					<MenuItemContentWrapper>
						<Typography>{menuItem.name}</Typography>
						<Icon iconName="ArrowForwardIos" />
					</MenuItemContentWrapper>
					<LinkDivider />
				</MenuItemWrapper>
			) : (
				<MenuItemWrapper position={relativeHeaderPosition}>
					<MenuItemContentWrapper>
						<a href={menuItem.url} target={menuItem.openInNewTab ? '_blank' : '_self'}>
							<Typography style={{ ...(menuItem.url === currentUrl ? { ...linkHoverColour, ...linkHoverUnderline } : {}) }}>
								{menuItem.name}
							</Typography>
						</a>
					</MenuItemContentWrapper>
					<LinkDivider />
				</MenuItemWrapper>
			)}

			{menuItem.items?.length
				? menuItem.items.map((item, i) => {
						return (
							<HeaderLink
								key={`${item.name}/${path}/${i}`}
								menuItem={item}
								navLocation={navLocation}
								setNavLocation={setNavLocation}
								path={path + `${NAV_SEPARATOR}${menuItem.name}`}
								currentUrl={currentUrl}
							/>
						);
				  })
				: null}
		</div>
	);
}
